import { Card, CardBody } from "@chakra-ui/react";
import React from "react";

/**
 * Renders a data card component
 * 
 * @param {Object} props The component properties
 * @returns A data card component
 */
const DataCard = ({ children, ...props }) => (
  <Card variant={"data"} borderRadius={"20px"} {...props}>
    <CardBody>{children}</CardBody>
  </Card>
);

export default React.memo(DataCard);
